<div class="app-container">

  <!-- navbar -->
  <nav class="navbar fixed-top navbar-expand-lg">
    <div class="header container-fluid">
      <div class="banner">
        <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" class="greater-icon"
          viewBox="0 0 44 40" width="18" height="18">
          <path class="banner__sign" fill="none" d="M15 8l14.729 14.382L15 35.367" stroke="#222222" stroke-width="8px">
          </path>
        </svg>
        &nbsp;
        <span class="banner__home" [routerLink]="''">matteoPhre/</span>
        <span class="banner__directory">{{breadcrumb_placeholder}}</span>
        <span class="banner__cursor"></span>
      </div>

      <div id="darktoggle-mobile" class="dropdown ml-auto">
        <button class="themetoggler" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="26" height="26"
            viewBox="0 0 24 24" fill="inherit">
            <path
              d="M19.54 5.08A10.61 10.61 0 0 0 11.91 2a10 10 0 0 0-.05 20 2.58 2.58 0 0 0 2.53-1.89 2.52 2.52 0 0 0-.57-2.28.5.5 0 0 1 .37-.83h1.65A6.15 6.15 0 0 0 22 11.33a8.48 8.48 0 0 0-2.46-6.25zM15.88 15h-1.65a2.49 2.49 0 0 0-1.87 4.15.49.49 0 0 1 .12.49c-.05.21-.28.34-.59.36a8 8 0 0 1-7.82-9.11A8.1 8.1 0 0 1 11.92 4H12a8.47 8.47 0 0 1 6.1 2.48 6.5 6.5 0 0 1 1.9 4.77A4.17 4.17 0 0 1 15.88 15z">
            </path>
            <circle cx="12" cy="6.5" r="1.5"></circle>
            <path d="M15.25 7.2a1.5 1.5 0 1 0 2.05.55 1.5 1.5 0 0 0-2.05-.55z"></path>
            <path d="M8.75 7.2a1.5 1.5 0 1 0 .55 2.05 1.5 1.5 0 0 0-.55-2.05z"></path>
            <path d="M6.16 11.26a1.5 1.5 0 1 0 2.08.4 1.49 1.49 0 0 0-2.08-.4z"></path>
          </svg>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li *ngFor="let theme of themeNames">
            <a class="dropdown-item" (click)="changeTheme(theme)"
              [ngClass]="{'activeClass': theme == lastThemeSelection}">
              <svg *ngIf="theme == lastThemeSelection" class="dropdown-item__hashicon"
                xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                viewBox="0 1 24 24" fill="inherit">
                <path
                  d="M20 14h-4.3l.73-4H20a1 1 0 0 0 0-2h-3.21l.69-3.81A1 1 0 0 0 16.64 3a1 1 0 0 0-1.22.82L14.67 8h-3.88l.69-3.81A1 1 0 0 0 10.64 3a1 1 0 0 0-1.22.82L8.67 8H4a1 1 0 0 0 0 2h4.3l-.73 4H4a1 1 0 0 0 0 2h3.21l-.69 3.81A1 1 0 0 0 7.36 21a1 1 0 0 0 1.22-.82L9.33 16h3.88l-.69 3.81a1 1 0 0 0 .84 1.19 1 1 0 0 0 1.22-.82l.75-4.18H20a1 1 0 0 0 0-2zM9.7 14l.73-4h3.87l-.73 4z"
                  fill="#FF1E56"></path>
              </svg>&nbsp;
              {{theme}}</a>
          </li>
        </ul>
      </div>

      <button class="navbar-toggler navbar-button" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <svg class="navbartoggler" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
          width="30" height="30" viewBox="0 0 24 24">
          <circle class="element" cx="4" cy="12" r="1" fill="#5670A1"></circle>
          <rect class="element" x="7" y="11" width="14" height="2" rx=".94" ry=".94" fill="#5670A1"></rect>
          <rect class="element" x="3" y="16" width="18" height="2" rx=".94" ry=".94" fill="#5670A1"></rect>
          <rect class="element" x="3" y="6" width="18" height="2" rx=".94" ry=".94" fill="#5670A1"></rect>
        </svg>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/']" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">cd
              ~</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/crondaily']" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show">cron@daily</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/posts']" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show">wget posts</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/whoami']" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show">whoami</a>
          </li>
          <li id="darktoggle-desktop" class="nav-item">
            <!-- <a (click)="changeTheme()">
                          <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="inherit">
                              <path d="M19.54 5.08A10.61 10.61 0 0 0 11.91 2a10 10 0 0 0-.05 20 2.58 2.58 0 0 0 2.53-1.89 2.52 2.52 0 0 0-.57-2.28.5.5 0 0 1 .37-.83h1.65A6.15 6.15 0 0 0 22 11.33a8.48 8.48 0 0 0-2.46-6.25zM15.88 15h-1.65a2.49 2.49 0 0 0-1.87 4.15.49.49 0 0 1 .12.49c-.05.21-.28.34-.59.36a8 8 0 0 1-7.82-9.11A8.1 8.1 0 0 1 11.92 4H12a8.47 8.47 0 0 1 6.1 2.48 6.5 6.5 0 0 1 1.9 4.77A4.17 4.17 0 0 1 15.88 15z"></path>
                              <circle cx="12" cy="6.5" r="1.5"></circle>
                              <path d="M15.25 7.2a1.5 1.5 0 1 0 2.05.55 1.5 1.5 0 0 0-2.05-.55z"></path>
                              <path d="M8.75 7.2a1.5 1.5 0 1 0 .55 2.05 1.5 1.5 0 0 0-.55-2.05z"></path>
                              <path d="M6.16 11.26a1.5 1.5 0 1 0 2.08.4 1.49 1.49 0 0 0-2.08-.4z"></path>
                          </svg>
                      </a> -->
            <div class="dropdown">
              <button class="themetoggler" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="26"
                  height="26" viewBox="0 0 24 24">
                  <path class="element"
                    d="M19.54 5.08A10.61 10.61 0 0 0 11.91 2a10 10 0 0 0-.05 20 2.58 2.58 0 0 0 2.53-1.89 2.52 2.52 0 0 0-.57-2.28.5.5 0 0 1 .37-.83h1.65A6.15 6.15 0 0 0 22 11.33a8.48 8.48 0 0 0-2.46-6.25zM15.88 15h-1.65a2.49 2.49 0 0 0-1.87 4.15.49.49 0 0 1 .12.49c-.05.21-.28.34-.59.36a8 8 0 0 1-7.82-9.11A8.1 8.1 0 0 1 11.92 4H12a8.47 8.47 0 0 1 6.1 2.48 6.5 6.5 0 0 1 1.9 4.77A4.17 4.17 0 0 1 15.88 15z">
                  </path>
                  <circle class="element" cx="12" cy="6.5" r="1.5"></circle>
                  <path class="element" d="M15.25 7.2a1.5 1.5 0 1 0 2.05.55 1.5 1.5 0 0 0-2.05-.55z"></path>
                  <path class="element" d="M8.75 7.2a1.5 1.5 0 1 0 .55 2.05 1.5 1.5 0 0 0-.55-2.05z"></path>
                  <path class="element" d="M6.16 11.26a1.5 1.5 0 1 0 2.08.4 1.49 1.49 0 0 0-2.08-.4z"></path>
                </svg>
              </button>

              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li *ngFor="let theme of themeNames;">
                  <a class="dropdown-item" (click)="changeTheme(theme)"
                    [ngClass]="{'activeClass': theme == lastThemeSelection}">
                    <svg *ngIf="theme == lastThemeSelection" class="dropdown-item__hashicon"
                      xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="22"
                      height="22" viewBox="0 1 24 24" fill="inherit">
                      <path
                        d="M20 14h-4.3l.73-4H20a1 1 0 0 0 0-2h-3.21l.69-3.81A1 1 0 0 0 16.64 3a1 1 0 0 0-1.22.82L14.67 8h-3.88l.69-3.81A1 1 0 0 0 10.64 3a1 1 0 0 0-1.22.82L8.67 8H4a1 1 0 0 0 0 2h4.3l-.73 4H4a1 1 0 0 0 0 2h3.21l-.69 3.81A1 1 0 0 0 7.36 21a1 1 0 0 0 1.22-.82L9.33 16h3.88l-.69 3.81a1 1 0 0 0 .84 1.19 1 1 0 0 0 1.22-.82l.75-4.18H20a1 1 0 0 0 0-2zM9.7 14l.73-4h3.87l-.73 4z"
                        fill="#FF1E56"></path>
                    </svg>&nbsp;
                    {{theme}}
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- render pages -->
  <router-outlet></router-outlet>
</div>